module.exports = __webpack_public_path__ + "img/shareText.a1536d67.png";